import styled from 'astroturf/react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
const textColorSecondary2 = 'var(--text-color-secondary-2, rgba(0, 105, 255, 1))'
import { BareButton } from '@calendly/ui/components/bare-button'
import { Button } from '@calendly/ui/components/button'
import { HtmlParser } from '@calendly/html-parser'
import { useFlag } from '@calendly/feature-check-react'

import { useI18n } from 'locales'
import { resendVerificationCode } from 'actions/scheduling'
import { schedulingParamsSelector } from 'selectors/scheduling'

import { EMAIL_VERIFICATION_CODE_LENGTH, EmailVerificationInput } from './email_verification_input'
import _ResendButton from "email_verification-ResendButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification.js?styleId=ResendButton";
import _ContinueButton from "email_verification-ContinueButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification.js?styleId=ContinueButton";
import _Container from "email_verification-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification.js?styleId=Container";
import _ResendPrompt from "email_verification-ResendPrompt.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification.js?styleId=ResendPrompt";


const ResendButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "ResendButton",
  styles: _ResendButton
})

const ContinueButton = /*#__PURE__*/styled(Button, null, {
  displayName: "ContinueButton",
  styles: _ContinueButton
})

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const ResendVerificationCode = ({ children }) => {
  const schedulingParams = useSelector(schedulingParamsSelector)
  const dispatch = useDispatch()
  const asyncBookingEnabled = useFlag('scheduling_platform_async_booking', false)
  const onClick = () => dispatch(resendVerificationCode(schedulingParams, asyncBookingEnabled))

  return (
    <ResendButton onClick={onClick}>
      {children}
    </ResendButton>
  )
}

export const EmailVerification = ({ handleSubmit, labelText, error, reset }) => {
  const { i18n } = useI18n()
  const [isVerificationCodeSent, setVerificationCodeSent] = useState(false)
  const [verificationCode, setVerificationCode] = useState('')

  const onVerificationCodeChange = (value) => {
    setVerificationCode(value)
    if (isVerificationCodeSent) {
      reset()
      setVerificationCodeSent(false)
    }
  }

  const handleContinue = () => {
    if (verificationCode.length === EMAIL_VERIFICATION_CODE_LENGTH && !isVerificationCodeSent) {
      setVerificationCodeSent(true)
      handleSubmit({ code: verificationCode })
    }
  }

  const ResendPrompt = /*#__PURE__*/styled('div', null, {
  displayName: "ResendPrompt",
  styles: _ResendPrompt
})

  return (
    <Container>
      <EmailVerificationInput
        value={verificationCode}
        labelText={labelText}
        onChange={onVerificationCodeChange}
        onFocus={reset}
        error={error}
      />
      <ContinueButton type="button" onClick={handleContinue}>
        {i18n.t('errors.booking.verification.continue')}
      </ContinueButton>
      <ResendPrompt>
        {HtmlParser(i18n.t('errors.booking.verification.resend_prompt'), {
          ResendVerificationCode
        })}
      </ResendPrompt>
    </Container>
  )
}
